"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StayFrostyAbilityHandler = exports.StayFrostyActorAbilityFactory = exports.StayFrostyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class StayFrostyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.StayFrosty;
        this.__typeName = "StayFrosty";
    }
}
exports.StayFrostyAbilityArgs = StayFrostyAbilityArgs;
let StayFrostyActorAbilityFactory = class StayFrostyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("StayFrosty", "AllEnemies", 0);
    }
};
StayFrostyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("StayFrosty")
], StayFrostyActorAbilityFactory);
exports.StayFrostyActorAbilityFactory = StayFrostyActorAbilityFactory;
let StayFrostyAbilityHandler = class StayFrostyAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Frost", 30)
                ],
                jitter: 0,
                effects: [
                    {
                        duration: Duration_1.Duration.Turns(3),
                        targetId,
                        effect: new core_1.SlowEffectArgs(1)
                    }
                ]
            })),
            onHit: (sequence, target) => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet", "behind"), "IceSnowflakeCircle"));
            },
        });
    }
};
StayFrostyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.StayFrosty)
], StayFrostyAbilityHandler);
exports.StayFrostyAbilityHandler = StayFrostyAbilityHandler;
